module.exports = __webpack_public_path__ + "static/img/icon-weChat.3dac1442.png";